module.exports = __webpack_public_path__ + "static/img/icon-enter-item1.d0a61d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-enter-item1.png
// module id = CFSS
// module chunks = 21